import InputFieldText from '../../../../components/input/floating-label/input-field/InputFieldText';
import Form from '../../../../components/form/Form';
import React, { useEffect } from 'react';
import { AdresseModel } from '../../../../models/AdresseModel';
import { StateModel } from '../../../../redux/store';
import { connect } from 'react-redux';
import { setAdresseField } from '../../../../redux/actions/adresserfassung';
import { Adresse } from '../../../../api';
import { nameof } from '../../../../utils/objectUtils';
import { ConfigModel } from '../../../../models/ConfigModel';

interface AllgemeinProps {
  adresse: AdresseModel;
  setAdresseField: (value: any, fieldName: string) => void;
  config: ConfigModel;
}

const Allgemein = (props: AllgemeinProps) => {
  useEffect(() => {
    props.setAdresseField(false, nameof<Adresse>('einmaladresse'));
  }, []);

  return (
    <Form classes='adr-allgemein-form'>
      <InputFieldText
        label='Nummer'
        tooltip={'Fremdnummer'}
        name={nameof<Adresse>('fremdnummer')}
        maxlength={20}
        classes='adr-fremdnummer'
        value={props.adresse.fremdnummer}
        onChangeHandler={value =>
          props.setAdresseField(value, nameof<Adresse>('fremdnummer'))
        }
        readonly={
          !!props.adresse.inUebertragung ||
          (!!props.adresse.inUebertragung &&
            (props.config.isAdresseTelefonEdit ||
              props.config.isAdresseKontaktEdit ||
              props.config.isAdresseUnsichtbarEdit ||
              props.config.isAdresseEinmaladresseEdit))
        }
      />
      <InputFieldText
        label='Matchcode'
        tooltip={
          'Matchcode wird automatisch vergeben, wenn die Adresse übertragen wurde.'
        }
        name={nameof<Adresse>('matchcode')}
        classes='adr-matchcode'
        value={props.adresse.matchcode}
        readonly={true}
        onChangeHandler={value =>
          props.setAdresseField(value, nameof<Adresse>('matchcode'))
        }
      />
      <InputFieldText
        label='Name'
        name={nameof<Adresse>('name')}
        maxlength={35}
        classes='adr-name'
        value={props.adresse ? props.adresse.name ?? '' : ''}
        onChangeHandler={value =>
          props.setAdresseField(value, nameof<Adresse>('name').trim())
        }
        readonly={
          !!props.adresse.inUebertragung ||
          (!!props.adresse.inUebertragung &&
            (props.config.isAdresseTelefonEdit ||
              props.config.isAdresseKontaktEdit ||
              props.config.isAdresseUnsichtbarEdit ||
              props.config.isAdresseEinmaladresseEdit))
        }
      />
      <div id='adr-zeile2-zeile3'>
        <InputFieldText
          label='Namenzusatz 2'
          name={nameof<Adresse>('zeile2')}
          maxlength={35}
          classes='adr-zeile2'
          value={props.adresse.zeile2}
          onChangeHandler={value =>
            props.setAdresseField(value, nameof<Adresse>('zeile2'))
          }
          readonly={
            !!props.adresse.inUebertragung ||
            (!!props.adresse.inUebertragung &&
              (props.config.isAdresseTelefonEdit ||
                props.config.isAdresseKontaktEdit ||
                props.config.isAdresseUnsichtbarEdit ||
                props.config.isAdresseEinmaladresseEdit))
          }
        />
        <InputFieldText
          label='Namenzusatz 3'
          name={nameof<Adresse>('zeile3')}
          maxlength={35}
          classes='adr-zeile3'
          value={props.adresse.zeile3}
          onChangeHandler={value =>
            props.setAdresseField(value, nameof<Adresse>('zeile3'))
          }
          readonly={
            !!props.adresse.inUebertragung ||
            (!!props.adresse.inUebertragung &&
              (props.config.isAdresseTelefonEdit ||
                props.config.isAdresseKontaktEdit ||
                props.config.isAdresseUnsichtbarEdit ||
                props.config.isAdresseEinmaladresseEdit))
          }
        />
      </div>

      <span className={'adr-einmaladresse'}>
        Einmaladresse &nbsp;
        <input
          checked={props.adresse.einmaladresse}
          onChange={event =>
            props.setAdresseField(
              event.target.checked,
              nameof<Adresse>('einmaladresse')
            )
          }
          type='checkbox'
          disabled={
            !!props.adresse.inUebertragung &&
            !props.config.isAdresseEinmaladresseEdit
          }
        />
      </span>
      <span className={'adr-unsichtbar'}>
        Unsichtbar &nbsp;
        <input
          checked={props.adresse.unsichtbar}
          onChange={event =>
            props.setAdresseField(
              event.target.checked,
              nameof<Adresse>('unsichtbar')
            )
          }
          type='checkbox'
          disabled={
            !!props.adresse.inUebertragung &&
            !props.config.isAdresseUnsichtbarEdit
          }
        />
      </span>
    </Form>
  );
};

const mapStateToProps = (state: StateModel) => ({
  adresse: state.Adresserfassung,
  config: state.Config,
});

export default connect(mapStateToProps, { setAdresseField })(Allgemein);
